import type { Case } from "./useRealtimeCases";

// Sales organisation (Oct 2026): from 2 500 € HT the client must be called, from 10 000 € HT the case is a priority (Paul, Oct 20).
export const CALL_FROM = 2500;
export const PRIORITY_FROM = 10000;
const CLOSED_STATUSES = new Set(["Supprimé", "Rejeté", "Signé", "Acompte reçu", "Versement complet"]);

type ValueFields = Pick<Case, "budget" | "budget_per_person" | "participants" | "pax">;

/** Requested total: stored budget, else budget per person × participants. */
export function estimatedTotal(c: ValueFields): number | null {
  const budget = positive(c.budget);
  if (budget !== null) return budget;
  const perPerson = positive(c.budget_per_person);
  const count = positive(c.participants) ?? positive(c.pax);
  return perPerson !== null && count !== null ? perPerson * count : null;
}
// Postgres numeric can reach the client as a string.
function positive(value: unknown): number | null {
  const n = typeof value === "string" && value.trim() !== "" ? Number(value) : value;
  return typeof n === "number" && Number.isFinite(n) && n > 0 ? n : null;
}

export type ValueTier = "priority" | "call" | null;

/** Alert level shown on open cases only: signed or archived cases need no call. */
export function valueTier(c: ValueFields & Pick<Case, "status">): ValueTier {
  if (CLOSED_STATUSES.has(c.status)) return null;
  const total = estimatedTotal(c);
  if (total === null) return null;
  if (total >= PRIORITY_FROM) return "priority";
  if (total >= CALL_FROM) return "call";
  return null;
}
